import { LEGACY_ORDER_STATUSES_LABEL } from '../../constants';

function getOrderSideValue(value) {
  return {
    1: 'buy',
    2: 'sell',
  }[value];
}

function isModifiedAndEditedState(title, executedQuantity) {
  if (
    (title === 'Modified' || title === 'OrderModified') &&
    executedQuantity > 0
  ) {
    return 'ModifiedAndEdited';
  }

  return title;
}

function transformOrder(data) {
  const [
    hostOrderNumber,
    orderNumber,
    orderId,
    companyTitle,
    instrumentName,
    quantity,
    entryDate,
    price,
    orderSideId,
    orderState,
    orderStateEnglishTitle,
    remainingQuantity,
    entryTime,
    blockedValue,
    lastPrice,
    errorDescription,
    instrumentIsin,
    personageId,
    investorTitle,
    accountRouteTypeId,
    accountRouteTypeTitle,
    parentExecutedQuantity,
    validityTypeId,
    validityTypeTitle,
    orderTypeTitle,
    executedQuantity,
    canceledQuantity,
    investorExchangeCodeId,
    entryDateTime,
    stateId,
  ] = data;

  return {
    hostOrderNumber,
    orderNumber,
    orderId,
    companyTitle,
    instrumentName,
    quantity,
    entryDate,
    price,
    orderSideId: getOrderSideValue(orderSideId),
    orderState,
    orderStateEnglishTitle,
    orderStateLabel:
      LEGACY_ORDER_STATUSES_LABEL[
        isModifiedAndEditedState(orderStateEnglishTitle, executedQuantity)
      ],
    remainingQuantity,
    entryTime,
    blockedValue,
    lastPrice,
    errorDescription,
    instrumentIsin,
    personageId,
    investorTitle,
    accountRouteTypeId,
    accountRouteTypeTitle,
    parentExecutedQuantity,
    validityTypeId,
    validityTypeTitle,
    orderTypeTitle,
    executedQuantity,
    canceledQuantity,
    investorExchangeCodeId,
    entryDateTime,
    stateId,
  };
}

function transformOrderData(response) {
  const { data = [] } = response;

  return data.map(transformOrder);
}

export { transformOrderData, getOrderSideValue, isModifiedAndEditedState };
